import { createSlice } from "@reduxjs/toolkit";
import {
  viewScholarship,
  singleScholarship,
  registerScholarship,
  updateScholarship,
  deleteScholarship,
  singleUserScholarship,
  approveScholarship,
  approvedScholarshipList,
} from "../actions/scholarshipAction";

const scholarshipSlice = createSlice({
  name: "scholarships",
  initialState: {
    scholarships: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.scholarships = action.payload;
      })
      .addCase(updateScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.scholarships = action.payload;
      })
      .addCase(deleteScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.scholarships = action.payload;
      })
      .addCase(singleScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.scholarships = action.payload;
      })
      .addCase(registerScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleUserScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleUserScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.scholarships = action.payload;
      })
      .addCase(singleUserScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.scholarships = action.payload;
      })
      .addCase(approveScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewScholarship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewScholarship.fulfilled, (state, action) => {
        state.loading = false;
        state.scholarships = action.payload;
      })
      .addCase(viewScholarship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approvedScholarshipList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approvedScholarshipList.fulfilled, (state, action) => {
        state.loading = false;
        state.scholarships = action.payload;
      })
      .addCase(approvedScholarshipList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default scholarshipSlice.reducer;
